<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 60px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <!-- <h1 class="display-2 text-white">Washing Machine</h1> -->
                        <!-- <p class="text-white mt-0 mb-5"></p> -->
                        <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">


                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">การตั้งค่าเครื่องซักผ้า</h3>
                                </div>
                                <!-- <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                                </div> -->
                            </div>
                        </div>
                        <template>

                           <!-- <hr> -->
                            <div class="pl-lg-4">
                                <h6 class="heading-small text-muted mb-4" style="font-size: 14px">ข้อมูลเครื่องซักผ้า</h6>
                                <form @submit.prevent>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="รหัสเครื่อง"
                                                        placeholder="รหัสเครื่อง"
                                                        input-classes="form-control-alternative"
                                                        v-model="washingData.name"
                                                        readonly
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                          <base-input alternative=""
                                                      label="ชื่อเครื่อง"
                                                      placeholder="ชื่อเครื่อง"
                                                      input-classes="form-control-alternative"
                                                      v-model="washingData.name_desc"
                                          />
                                        </div>
                                    </div>
                                    <hr>
                                    <h6 class="heading-small text-muted mb-4" style="font-size: 14px">ตั้งค่าราคา</h6>
                     
                                    <div class="row">
                                        <div class="col-lg-6" v-for="data in washingData.modes">
                                            <!-- <base-input alternative=""
                                                        label="โหมด 30 นาที (บาท)"
                                                        placeholder="โหมด 30 นาที (บาท)"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.modeOne"
                                            /> -->
                                            
                                            <label for="price">{{ data.mode_desc }} (บาท)</label>
                                            <input id="price" class="form-control" type="text" name="price" v-model="data.price" placeholder="ราคา (บาท)">
                                        </div>

                                        <!-- <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="เลขเครื่อง"
                                                        placeholder="เลขเครื่อง"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.machineNumber"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="โหมด 30 นาที (บาท)"
                                                        placeholder="โหมด 30 นาที (บาท)"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.modeOne"
                                            />
                                        </div> -->
                                    </div><br>
                                    <h6 class="heading-small text-muted mb-4" style="font-size: 14px; " v-if="washingData.spq_wm_id !== null && loaded == true" >ราคาหยอดเหรียญกับแสกนไม่ตรงกัน <input type="checkbox"  id="check_coin_notequal" name="check_coin_notequal" v-on:change="check_coin_notequal($event)" v-model="washingData.spq_qr_diff_coin_price"></h6>

                                    <!-- <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="โหมด 60 นาที (บาท)"
                                                        placeholder="โหมด 60 นาที (บาท)"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.modeTwo"
                                            />
                                        </div>
                                    </div> -->
                                    <br>
                                    <!-- <div v-loading="isLoading" :loading-options="{ options }"></div> -->
                                    <div class="text-center">
                                      <base-alert type="default" v-show="isLoading">
                                          <i class="ni ni-world-2"></i> กำลังโหลดกรุณารอสักครู่...
                                      </base-alert>
                                      <button class="btn btn-primary" type="button" name="button" v-on:click="update()">บันทึก</button> | 

                                      <button class="btn btn-success" type="button" name="button" v-on:click="qrcode2()">พิมพ์ QRCode(ขนาดปกติ)</button>
                                      <button class="btn btn-success" type="button" name="button" v-on:click="qrcode()">พิมพ์ QRCode(ขนาดเล็ก)</button>
                                      <!-- <button class="btn btn-success" @click="isLoading = true">ดู QRCode</button> -->
                                    </div>
                                </form>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import JwService from '../service/justwash';

  export default {
    name: 'user-profile',
    data() {
      // console.log(this.washingData);
      return {
        spq_wm_id : '',
        loaded : false,
        washingData : {},
        qrcodeData : {},
        isLoading: false,
        
      }
    },
    methods: {
      update:function() {
       
        
        if (this.washingData.spq_qr_diff_coin_price == true) {
            this.washingData.spq_qr_diff_coin_price = 1;
          } else {
            this.washingData.spq_qr_diff_coin_price = 0;
          }

        // console.log(this.washingData);

        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.UpdateWashingMachine',
          data: {
            modes : JSON.stringify(this.washingData)
          },
          headers: {
            'Authorization' : 'Token '+localStorage.getItem('accessToken')
          }
        }).then((response) => {
          if (response.data.message.status == true) {
            this.washingData = response.data.message.data.data;
            // console.log(this.washingData);
            alert('บันทึกข้อมูลเรียบร้อยแล้ว');
            // this.$router.push('/setting/'+this.$route.params.id);
          } else {
            alert('ไม่สามารถบันทึกข้อมูลได้');
            // console.log(response.data.message);
            // this.$router.push('/login');
          }
        }).catch(error => {
          console.log(error);
          this.$router.push('/login');
        });
      },
      qrcode:function() {
        this.isLoading = true;
        // console.log('qrcode');
        // alert('กำลังโหลดกรุณารอสักครู่...');
        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetQrCodePdf',
          data: {
            washing_machine_id: this.$route.params.id
          },
          headers: {
            'Authorization' : 'Token '+localStorage.getItem('accessToken')
          }
        }).then((response) => {
          // console.log(this.qrcodeData);
          if (response.data.message.status == true) {
            this.qrcodeData = response.data.message.data.data;
            // console.log(this.qrcodeData);
            // this.$router.push('/setting/'+this.$route.params.id);
            this.isLoading = false;
            window.location.href = this.qrcodeData;
          } else {
            this.$router.push('/login');
          }
        }).catch(error => {
          console.log(error);
          this.$router.push('/login');
        });
      },

      qrcode2:function() {
        this.isLoading = true;
        // console.log('qrcode');
        // alert('กำลังโหลดกรุณารอสักครู่...');
        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetQrCodePdf2',
          data: {
            washing_machine_id: this.$route.params.id
          },
          headers: {
            'Authorization' : 'Token '+localStorage.getItem('accessToken')
          }
        }).then((response) => {
          // console.log(this.qrcodeData);
          if (response.data.message.status == true) {
            this.qrcodeData = response.data.message.data.data;
            // console.log(this.qrcodeData);
            // this.$router.push('/setting/'+this.$route.params.id);
            this.isLoading = false;
            window.location.href = this.qrcodeData;
          } else {
            this.$router.push('/login');
          }
        }).catch(error => {
          console.log(error);
          this.$router.push('/login');
        });
      },
      check_coin_notequal(v) {
          // console.log(v.target.checked);

          if (v.target.checked == true) {
            this.washingData.spq_qr_diff_coin_price = 1;
          } else {
            this.washingData.spq_qr_diff_coin_price = 0;
          }
          // console.log(this.washingData);
       }
    },
    mounted() {
      // console.log(this.$route.params.id);
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetWashingMachine',
        data: {
          washing_machine_id: this.$route.params.id
        },
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
          this.washingData = response.data.message.data.data;
          // console.log(this.washingData);
          // console.log(this.washingData.spq_qr_diff_coin_price);
          // console.log(typeof(this.washingData.spq_qr_diff_coin_price));
           if (this.washingData.spq_qr_diff_coin_price == 1) {
            this.washingData.spq_qr_diff_coin_price = true;
          } else {
            this.washingData.spq_qr_diff_coin_price = false;
          }
          this.loaded = true;
          // this.$router.push('/profile');
        } else {
          this.$router.push('/login');
        }
      }).catch(error => {
        console.log(error);
        this.$router.push('/login');
      });
    }
  };
</script>
<style></style>
